import React, { useEffect, useState } from "react";
import { MdLockOpen, MdOutlineFileCopy } from "react-icons/md";
// import { AiFillLike, AiOutlineDislike } from "react-icons/ai";
// import UserPlusCircle from "../../../src/assets/images/user-plus-circle.svg";
// import { Rating } from "@mui/material";
import { Button, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { SAVIYANT_URL } from "../../constants/Constant";
// import AlertAccessRequestDialog from "../utils/Modals/AlertAccessRequestDialog";
// import { MdOutlineContentCopy } from "react-icons/md";
import ReusableCertifiedIcon from "./ReusableCertifiedIcon";
import { BsPencilFill } from "react-icons/bs";
import { GiCheckMark } from "react-icons/gi";
import { RxCross2 } from "react-icons/rx";
import { Input } from "antd";
// import _ from "lodash";
import { Switch } from "antd";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DatasetDetailsInfoModal from "./DatasetDetailsInfoModal";
import DatasetAADDetailsInfoModal from "./DatasetAADDetailsInfoModal";
import { useLocation } from "react-router-dom";
// import { GiCheckMark } from "react-icons/gi";
// import { RxCross2 } from "react-icons/rx";

const DatasetDetailsMessageMain = ({
  id,
  modaldata,
  copydataset,
  certifiedetails,
  desctoggle,
  savedescription,
  editToggle,
  // setValue,
  description,
  setDatasetDescription,
  value,
  toggleloading,
  updateCertificationDetails,
  showModal,
  sensitivitytypeclass,
}) => {
  // const [confirmAccessRequest, setConfirmAccessRequest] = useState(false);
  // const [star, setStar] = useState(0);
  const location = useLocation();
  const isMetric = location.pathname.includes("metric");

  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [openInfoDialog1, setOpenInfoDialog1] = useState(false);

  // const [showDescriptionPencil, setShowDescriptionPencil] = useState(false);
  // const [showSensitivityPencil, setShowSensitivityPencil] = useState(false);


  useEffect(() => {
    setDatasetDescription(value);
  }, [value])

  // const [
  //   showSecurityclassificationPencil,
  //   setShowSecurityclassificationPencil,
  // ] = useState(false);
  // const [showTagsPencil, setshowTagsPencil] = useState(false);

  let certifieddata = certifiedetails?.certifiedFlag ? (
    <ReusableCertifiedIcon certifieddata={certifiedetails} />
  ) : (
    ""
  );

  // const classificationType = () => {
  //   let confidenceFlag = modaldata.securityClassification?.some(function (
  //     object
  //   ) {
  //     return object.indexOf("confidential") > -1;
  //   });
  //   let internalFlag = modaldata.securityClassification?.some(function (
  //     object
  //   ) {
  //     return object.indexOf("internal") > -1;
  //   });
  //   let publicFlag = modaldata.securityClassification?.some(function (object) {
  //     return object.indexOf("public") > -1;
  //   });

  //   if (confidenceFlag) {
  //     setSensitivityTypeClass("sensitivity-confidencial");
  //   } else if (internalFlag) {
  //     setSensitivityTypeClass("sensitivity-internal");
  //   } else if (publicFlag) {
  //     setSensitivityTypeClass("sensitivity-public");
  //   } else {
  //     setSensitivityTypeClass("bg-white");
  //   }
  //   // setSensitivityType("#008000")
  // };
  // useEffect(() => {
  //   classificationType();
  // }, [modaldata]);

  const updateCertificatiion = (flag) => {
    updateCertificationDetails(flag);
  };

  // const handleDescriptionClick = () => {
  //   setShowDescriptionPencil((prev) => !prev);
  // };

  // const handleSensitivityClick = () => {
  //   setShowSensitivityPencil((prev) => !prev);
  // };

  // const handleSecurityClassificationClick = () => {
  //   setShowSecurityclassificationPencil((prev) => !prev);
  // };

  // const handleTagsClick = () => {
  //   setshowTagsPencil((prev) => !prev);
  // };

  // const handlePencilClick = (field) => {
  //   showModal(field);
  //   if (field === "description") {
  //     setShowDescriptionPencil(false);
  //   } else if (field === "sensitivity") {
  //     setShowSensitivityPencil(false);
  //   } else if (field === "securityClassification") {
  //     setShowSecurityclassificationPencil(false);
  //   } else if (field === "tags") {
  //     setshowTagsPencil(false);
  //   }
  // };

  return (
    <div
      className="details-head-container"
      style={{
        width: "100%",
        // border:"1px solid blue"
      }}
    >
      <div className="dhc-header-line">
        <div className="dhc-header-line-left">
          <h3>{modaldata.name}</h3>
          {modaldata.securityClassification &&
            modaldata.securityClassification.length > 0 ? (
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip id="button-tooltip">
                  <span>
                    {modaldata.securityClassification
                      ?.map((item) => {
                        return item?.replace("securityclassification.", "");
                      })
                      .toString()}
                  </span>
                </Tooltip>
              }
            >
              <p className={"dhc-header-line-lock-tag " + sensitivitytypeclass}>
                <MdLockOpen size={14} color="white" />
              </p>
            </OverlayTrigger>
          ) : (
            ""
          )}
          {modaldata?.producer === 'pipedream' ? "" : (
            isMetric ? "" : (
              <>
                <p className="dhc-header-line-access1">
                  <Button
                    className="governace-access"
                    onClick={() => {
                      if (isMetric) {
                      } else {
                        window.open(SAVIYANT_URL, "_blank");
                      }
                    }}
                  >
                    {isMetric ? "Explore" : "Request access"}
                  </Button>
                </p>
                <InfoOutlinedIcon
                  style={{
                    marginLeft: "-8px",
                    cursor: "pointer",
                  }}
                  onClick={() => setOpenInfoDialog(true)}
                />
              </>
            )

          )}
        </div>
        <div className="dhc-header-line-left">
          <div className="dhc-key-labels">
            <span>Certified: </span>
            <p className="dhc-header-message-tag1 mx-1">
              <Switch
                size="small"
                style={{
                  // padding: "1px",
                  top: 0,
                  backgroundColor: certifiedetails?.certifiedFlag
                    ? "green"
                    : "",
                }}
                checkedChildren={<GiCheckMark />}
                unCheckedChildren={<RxCross2 />}
                checked={certifiedetails?.certifiedFlag}
                onChange={updateCertificatiion}
                loading={toggleloading}
              />
            </p>
          </div>

          {/* Below will be commented untill the backend api is completed */}
          {/* <p
            style={{
              padding: "0 0.4rem",
              border: "1px solid #d3d3d3",
              borderRadius: "18px",
              marginBottom: "0",
              display: "flex",
              alignItems: "center",
              gap: "0.2rem",
              fontSize: "10px",
            }}
          >
            Follow
            <img src={UserPlusCircle} alt="userPlusIcon" />
          </p> */}
          <p>
            {/* <FaCheckCircle size={18} style={{ fill: "#4C9244" }} /> */}
            {certifieddata}
          </p>
          {/* <p className="dhc-header-line-id"  
          >ID: {id}</p> */}
          {/* <p className="dhc-header-line-id" title={`ID: ${id}`}>
            ID: {id?.substring(0, 1000)}
            <MdOutlineContentCopy size={20} />
          </p> */}
          {!isMetric ? (
            <div className="addgroup-copy dhc-header-wrapper d-flex">
              <p className="dhc-header-line-id">ID: {id?.substring(0, 1000)}</p>
              <p
                className="px-2"
                onClick={() =>
                  copydataset(id, "Dataset ID Copied Successfully !")
                }
              >
                <MdOutlineFileCopy size={15} color="black" />
              </p>
            </div>
          ) : (""
            // <Button className="governace-access-green">70% Metadata Score</Button>
          )}
        </div>
      </div>

      {/* <div className="dhc-body-line">
        <div className="dhc-header-line-left">
          <span
            style={{ fontSize: "18px", fontWeight: "800", color: "#000000" }}
          >
            Title
          </span>
          <p
            style={{
              padding: "0.2rem 0.8rem",
              border: "1px solid #d3d3d3",
              borderRadius: "4px",
              marginBottom: "0",
            }}
          >
            Title.xlsx
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        
          <Rating
            name="dataset-likes"
            value={star}
            onChange={(event, newValue) => {
              setStar(newValue);
            }}
          />
        </div>
      </div> */}
      <Row className="py-2">
        <Col xs={10} lg={10}>
          <div className="w-100">
            {(!desctoggle && value == null) ||
              (!desctoggle && value.length === 0) ? (
              <>
                <div className="d-flex">
                  {!value ? (
                    <p className="px-21 cursor-pointer">
                      Update Dataset Description...
                    </p>
                  ) : value ? (
                    <span>{value}</span>
                  ) : (
                    ""
                  )}

                  <span className="px-21">
                    <BsPencilFill
                      size={15}
                      className="stroke-2 cursor-pointer "
                      onClick={editToggle}
                    />
                  </span>
                </div>
              </>
            ) : (
              <>
                {!desctoggle && value && value?.length > 0 ? (
                  <>
                    <span>
                      {value}
                      <span className="px-2">
                        <BsPencilFill
                          size={15}
                          className="stroke-2 cursor-pointer "
                          onClick={editToggle}
                        />
                      </span>
                    </span>
                  </>
                ) : (
                  ""
                )}
              </>
            )}
            {desctoggle ? (
              <Input.TextArea
                style={{ width: 1000 }}
                disabled={!desctoggle}
                size="medium"
                placeholder="Table description goes here."
                defaultValue={value}

                value={description}
                onChange={(e) => setDatasetDescription(e.target.value)}
                autoSize={
                  desctoggle
                    ? {
                      minRows: 2,
                      maxRows: 3,
                    }
                    : {}
                }
                className="header-textarea text-dark"
              />
            ) : (
              ""
            )}
            {desctoggle ? (
              <>
                <div className="d-flex float-end">
                  <div onClick={(e) => savedescription(description)}>
                    <GiCheckMark size={15} className="me-3 cursor-pointer" />
                  </div>
                  <div>
                    <RxCross2
                      size={15}
                      className="stroke-2 cursor-pointer "
                      onClick={editToggle}
                    />
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </Col>
        {modaldata.type && modaldata.type.length > 0 ? (
          <Col xs={2} lg={2}>
            <div
              className="p-1"
              style={{ width: "fit-content", float: "right" }}
            >
              <p
                style={{
                  backgroundColor: "#FFF1C2",
                  borderRadius: "18px",
                  padding: "5px 15px",
                  color: "#000000",
                  fontSize: "12px",
                }}
              >
                Asset type: {modaldata.type}
              </p>
            </div>
          </Col>
        ) : (
          ""
        )}
      </Row>
      <Row className="py-2">
        <Col>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            {modaldata.tags && modaldata.tags.toString()?.length > 0 ? (
              modaldata.tags.map((tag, idx) => (
                <p className="dhc-header-message-tag m-1">
                  {" "}
                  {tag.tagName.toString()}
                </p>
              ))
            ) : (
              <div className="d-flex">
                <p className="px-21 cursor-pointer">Update tags...</p>
              </div>
            )}
            <span className="px-2">
              <BsPencilFill
                size={15}
                className="stroke-2 cursor-pointer "
                // onClick={handleTagsClick}
                onClick={() => showModal("tags")}
              />
            </span>
          </div>
        </Col>
      </Row>
      <Row></Row>
      {/* <div className="dhc-body-line" style={{ marginTop: "0.2rem" }}>
        <div className="dhc-header-line-left">
          <p
            style={{
              padding: "0.2rem 0.8rem",
              border: "1px solid #d3d3d3",
              borderRadius: "4px",
              marginBottom: "0",
              fontSize: "12px",
            }}
          >
            Publisher: John Doe
          </p>
          <p
            style={{
              padding: "0 0.4rem",
              border: "1px solid #d3d3d3",
              borderRadius: "18px",
              marginBottom: "0",
              display: "flex",
              alignItems: "center",
              gap: "0.2rem",
              fontSize: "10px",
            }}
          >
            Follow
            <img src={UserPlusCircle} alt="userPlusIcon" />
          </p>
        </div>
      </div> */}

      <div
        className="dhc-body-line"
        style={{
          marginTop: ".2rem",
        }}
      ></div>

      <Row>
        {modaldata.product || modaldata.platform || modaldata.orgModel ? (
          <Col>
            {modaldata.product && modaldata.product.toString()?.length > 0 ? (
              <div className="dhc-key-labels">
                <span>Product: </span>
                {/* {modaldata.orgModel &&
                  modaldata.orgModel.map((product, idx) => ( */}
                <p className="dhc-header-value">
                  {" "}
                  {modaldata.product.toString()}
                </p>
                {/* ))} */}
              </div>
            ) : (
              ""
            )}
            {modaldata.platform && modaldata.platform.toString()?.length > 0 ? (
              <div className="dhc-key-labels">
                <span>Platform: </span>
                {modaldata.platform &&
                  modaldata.platform.map((plateform, idx) => (
                    <p className="dhc-header-value"> {plateform.toString()}</p>
                  ))}
              </div>
            ) : (
              ""
            )}

            {modaldata.orgModel && modaldata.orgModel.toString()?.length > 0 ? (
              <div className="dhc-key-labels">
                <span>Portfolio:</span>
                {modaldata.orgModel &&
                  modaldata.orgModel.map((orgmodel, idx) => (
                    <p className="dhc-header-value"> {orgmodel.toString()}</p>
                  ))}
              </div>
            ) : (
              ""
            )}
          </Col>
        ) : (
          ""
        )}

        <Col>
          {modaldata.datasetSchema &&
            modaldata.datasetSchema.toString()?.length > 0 ? (
            <div className="dhc-key-labels" style={{ marginTop: "10px" }}>
              <span>Schema:</span>
              <p className="dhc-header-value mx-1">
                {" "}
                {modaldata.datasetSchema.toString()}
              </p>
            </div>
          ) : (
            ""
          )}

          {modaldata.domains && modaldata.domains.toString()?.length > 0 ? (
            <div className="dhc-key-labels">
              <span>Domain: </span>

              {modaldata.domains &&
                modaldata.domains.map((domains, idx) => (
                  <p className="dhc-header-value"> {domains.toString()}</p>
                ))}
            </div>
          ) : (
            ""
          )}
        </Col>
      </Row>

      <hr className="hr" />
      {modaldata?.producer === 'pipedream' ? "" : (
        <Row>
          {modaldata.aadGroupNames && modaldata.aadGroupNames.length > 0 && (
            <>
              <p className="py-1">AAD Group Names</p>
              {modaldata.aadGroupNames.map((aadgroup, idx) => (
                <p className="dhc-path-link-tags" key={idx}>
                  <p className="path-copy">{aadgroup.toString()}</p>
                  <MdOutlineFileCopy
                    className="curson-property"
                    size={14}
                    onClick={() =>
                      copydataset(
                        aadgroup,
                        "AAD Group Name Copied Successfully!"
                      )
                    }
                  />
                </p>
              ))}
              <InfoOutlinedIcon
                style={{
                  marginLeft: "0px",
                  width: "2em",
                  marginTop: "5px",
                  cursor: "pointer",
                }}
                onClick={() => setOpenInfoDialog1(true)}
              />
            </>
          )}
        </Row>

      )}

      {/* <Row>
        {modaldata.path && modaldata.path.toString()?.length > 0 ? (
          <>
            <p className="py-1">ADLS Details</p>
            <p className="dhc-path-link-tags">
              <span>adls path: </span>
              <p className="path-copy">{modaldata.path}</p>
              <MdOutlineFileCopy
                className="curson-property"
                size={14}
                onClick={() =>
                  copydataset(modaldata.path, "Adls path Copied Successfully !")
                }
              />
            </p>
          </>
        ) : (
          ""
        )}

        {modaldata.uris && modaldata.uris.toString()?.length > 0 ? (
          <p className="dhc-path-link-tags">
            <span>uris: </span>
            <p className="path-copy">{modaldata.uris}</p>
            <MdOutlineFileCopy
              className="curson-property"
              size={14}
              onClick={() =>
                copydataset(modaldata.uris, "uris Copied Successfully !")
              }
            />
          </p>
        ) : (
          ""
        )}
      </Row> */}

      {/* <Row
        className="dhc-body-line "
        style={{
          marginTop: "0.2rem",
        }}
      >
        <Col xs={8}>
          {console.log(
            "(_.isEmpty(modaldata.certifiedetails))l :",
            _.isEmpty(certifiedetails)
          )} */}
      {/* {certifiedetails && !_.isEmpty(certifiedetails) ? (
            <div className="dhc-key-labels">
              <span>Certify Dataset:</span>
              <p className="dhc-header-message-tag1 mx-1">
                <Switch
                  size="small"
                  style={{
                    // padding: "1px",
                    top: 0,
                    backgroundColor: certifiedetails?.certifiedFlag
                      ? "green"
                      : "",
                  }}
                  checkedChildren={<GiCheckMark />}
                  unCheckedChildren={<RxCross2 />}
                  checked={certifiedetails?.certifiedFlag}
                  onChange={updateCertificatiion}
                  loading={toggleloading}
                />
              </p>
            </div>
          ) : (
            ""
          )} */}
      {/* {certifiedetails?.certifiedFlag && !_.isEmpty(certifiedetails) ? (
            <div className="dhc-key-labels">
              <span>Certified by :</span>
              <p className="dhc-header-message-tag mx-1">
                {" "}
                {certifiedetails?.certifiedBy}
              </p>
            </div>
          ) : (
            ""
          )} */}

      {/* <div className="d-flex"> */}
      {/* <div className="dhc-key-labels">
              <span>Security classification:</span>
              {modaldata.securityClassification &&
                modaldata.securityClassification.toString()?.length > 0 ? (
                modaldata.securityClassification.map((classification, idx) => (
                  <p className="dhc-header-message-tag m-1">
                    {" "}
                    {classification.replace("securityclassification.", "")}
                  </p>
                ))
              ) :
              

                (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 300 }}
                    overlay={<Tooltip id="tooltip">Click to edit</Tooltip>}
                  >
                    <p className="px-2 cursor-pointer" onClick={handleSecurityClassificationClick}>
                      Update classification...
                    </p>
                  </OverlayTrigger>
                )}


            </div> */}
      {/* {showSecurityclassificationPencil && (
              <div
                name="securityClassification"
                onClick={() =>
                  handlePencilClick("securityClassification")
                }
              >
                <BsPencilFill size={15} className="stroke-2 cursor-pointer " />
              </div>
            )} */}
      {/* </div> */}
      {/* <div className="d-flex">
            <div className="dhc-key-labels">
              <span>Sensitivity:</span>
              {modaldata.sensitivity &&
                modaldata.sensitivity.toString()?.length > 0 ? (
                modaldata.sensitivity.map((sensitivity, idx) => (
                  <p className="dhc-header-message-tag m-1">
                    {" "}
                    {sensitivity.replace("securityclassification.", "")}
                  </p>
                ))
              ) :

                (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 300 }}
                    overlay={<Tooltip id="tooltip">Click to edit</Tooltip>}
                  >
                    <p className="px-2 cursor-pointer" onClick={handleSensitivityClick}>
                      Update sensitivity...
                    </p>
                  </OverlayTrigger>
                )}

            </div>
            {showSensitivityPencil && (
              <div
                name="sensitivity"
                onClick={() => handlePencilClick("sensitivity")}
              >
                <BsPencilFill size={15} className="stroke-2 cursor-pointer" />
              </div>
            )}
          </div> */}

      {/* <div className="d-flex">
            <span>Tags :</span>
            <div
              style={{
                // marginTop: "0.2rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // border: "1px solid #d3d3d3",
                // borderRadius: "15px",
              }}
            >
              {modaldata.tags && modaldata.tags.toString()?.length > 0 ? (
                modaldata.tags &&
                modaldata.tags.map((tag, idx) => (
                  <p className="dhc-header-message-tag m-1">
                    {" "}
                    {tag.tagName.toString()}
                  </p>
                ))
              ) : (
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 300 }}
                  overlay={<Tooltip id="tooltip">Click to edit</Tooltip>}
                >
                  <p className="px-2 cursor-pointer" onClick={handleTagsClick}>
                    Update tags...
                  </p>
                </OverlayTrigger>
              )}
            </div>

            {showTagsPencil && (
              <div name="tags" onClick={() => handlePencilClick("tags")}>
                <BsPencilFill size={15} className="stroke-2 cursor-pointer " />
              </div>
            )}
          </div> */}

      {/* <div className="d-flex">
            <div className="dhc-key-labels">
              <span>Data Owner :</span>
              {(modaldata.owner && modaldata.owner.toString()?.length > 0) ?
                (modaldata.owner.map((owner, idx) => <p className="dhc-header-message-tag m-1">  {owner}</p>)) : (<p className="dhc-header-message-tag1 m-1"><i>Update owner...</i></p>)}
            </div>
            <div
              name="owner"
              onClick={() => showModal("owner")}
            >
              <BsPencilFill size={15} className="stroke-2 cursor-pointer " />
            </div>
          </div>
           */}

      {/* </Col> */}

      {/* <Col
          xs={4}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          {modaldata.aadGroupNames && modaldata.aadGroupNames.length > 0 && (
            <>
              <span style={{ marginRight: "50px" }}>AAD group names:</span>
              {modaldata.aadGroupNames.map((aadgroup, idx) => (
                <p className="dhc-path-link-tags" key={idx}>
                  <p className="path-copy">{aadgroup.toString()}</p>
                  <MdOutlineFileCopy
                    className="curson-property"
                    size={14}
                    onClick={() =>
                      copydataset(
                        aadgroup,
                        "AAD Group Name Copied Successfully!"
                      )
                    }
                  />
                </p>
              ))}
            </>
          )}

          {modaldata.path && modaldata.path.toString()?.length > 0 ? (
            <p className="dhc-path-link-tags" style={{ marginTop: "20px" }}>
              <span>adls path:</span>
              <p className="path-copy">{modaldata.path}</p>
              <MdOutlineFileCopy
                className="curson-property"
                size={14}
                onClick={() =>
                  copydataset(modaldata.path, "Adls path Copied Successfully !")
                }
              />
            </p>
          ) : (
            ""
          )}

          <p className="dhc-path-link-tags">
            <span>dremio:</span>
            <p className="path-copy">
              mainfolder/subfolder/filename.dremio....id
            </p>
            <MdOutlineFileCopy className="curson-property" size={14} />
          </p>
          <p className="dhc-path-link-tags">
            <span>trino:</span>
            <p className="path-copy">
              mainfolder/subfolder/filename.trino....id
            </p>
            <MdOutlineFileCopy className="curson-property" size={14} />
          </p>
          <p className="dhc-path-link-tags">
            <span>savyint:</span>
            <p className="path-copy">mlitbi...adls...ds...cleansed...sfdc</p>
            <MdOutlineFileCopy className="curson-property" size={14} />
          </p>
        </Col> */}
      {/* </Row> */}
      {/* {confirmAccessRequest && (
        <AlertAccessRequestDialog
          confirmAccessRequest={confirmAccessRequest}
          setConfirmAccessRequest={setConfirmAccessRequest}
          // moreID={moreID}
        />
      )} */}
      <DatasetDetailsInfoModal
        open={openInfoDialog}
        onClose={() => setOpenInfoDialog(false)}
      />
      <DatasetAADDetailsInfoModal
        open={openInfoDialog1}
        onClose={() => setOpenInfoDialog1(false)}
      />
    </div>
  );
};

export default DatasetDetailsMessageMain;
